const Role = {
  ADMIN: 'Super Usuário',
  ORGANIZATION_ADMIN: 'Administrador da Organização',
  CLIENT_ADMIN: 'Administrador Geral',
  CLINIC_ADMIN: 'Administrador da Clinica',
  DOCTOR: 'Médico',
  ANALYST: 'Analista',
  USER: 'Usuário',
  INTEGRATION: 'Integração'
}

const ExamStatus = {
  ANALYZED: 'ANALYZED',
  CONCLUDED: 'CONCLUDED',
  IN_PROGRESS: 'IN_PROGRESS',
  CANCELED: 'CANCELED'
}


const AssistStatus = {
  CONCLUDED: 'CONCLUDED',
  IN_PROGRESS: 'IN_PROGRESS',
  CANCELED: 'CANCELED'
}

const FoodIntakeStatus = {
  JEJUM: 'FASTING',
  CASUAL: 'CASUAL'
}

const previousDiagnosisOfDiabetes = {
  NO: 'NO',
  TYPE_1: 'TYPE_1',
  TYPE_2: 'TYPE_2'
}

export { Role, AssistStatus, ExamStatus, FoodIntakeStatus, previousDiagnosisOfDiabetes }
